const POSTER_BASE = 'https://api2b.pro/poster/';

export const posterFromSlug = (game = {}) => {
  const slug = game?.slug;
  if (slug) return `${POSTER_BASE}${slug}`;

  const code = (game?.code || '')
    .replace(/\s\s/g, ' ')
    .replace(/\s/g, '_')
    .toLowerCase();

  const name = (game?.name || '')
    .replace(/\s\s/g, ' ')
    .replace(/!/g, '')
    .replace(/\?/g, '')
    .replace(/\//g, '')
    .replace(/\s/g, '_')
    .replace(/'/g, '_')
    .toLowerCase();

  const fallbackSlug = `${code}_${name}.png`
    .replace(/\s\s/g, ' ')
    .replace(/\s/g, '_');

  return `${POSTER_BASE}${fallbackSlug}`;
};
